import React, { useState, useEffect } from "react";
import BillRecap from "Components/BillRecap/BillRecap";
import Button from "Components/button/Button";
import ServicesRecapTable from "Components/servicesRecapTable/ServicesRecapTable";
import TranslatedString from "Components/TranslatedString";
import t, { getAccountTypeTranslation } from "Utils/translation";
import SmallModal from "Components/smallModal/smallModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { deliveryPlans } from "@/config";
import { useSWRConfig } from "swr";
import { alertError } from "Utils/alerts";

const formatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, {
  maximumFractionDigits: 0,
});

const Recap = ({
  stepper,
  formData,
  onFormCancel,
  api,
  resetForm,
  isFormLoading,
  unsetFormLoading,
  setFormLoading,
  setFormErrors,
  // setNewUserData,
  handleFormResponseErrors,
  onFormSubmit = () => {},
  accountData,
  selectedTier,
  isReseller,
  hidePrices,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pickedPlan, setPickedPlan] = useState(null);
  const history = useHistory();

  const { mutate } = useSWRConfig();

  useEffect(() => {
    setPickedPlan(formData.plan);
  }, []);

  let appliedDiscount = null;
  if (isReseller) {
    const discount = selectedTier.special_tiers.find((t) => t.name === "Reseller");
    if (discount) appliedDiscount = discount;
  }

  const submitForm = async (e) => {
    e.preventDefault();

    setFormLoading(true);

    try {
      await api.updateDeliveryAccountInfo({
        id: accountData.id,
        productId: formData.product_id,
        paymentMethod: formData.payment_method,
      });

      setFormErrors({});
    } catch (error) {
      console.log(error);

      alertError("Error changing plan");
      unsetFormLoading(false);

      return;
    }

    unsetFormLoading(false);

    onFormSubmit();
    setIsModalOpen(true);
  };

  return (
    <div className="screenContainer flexAlignCenter">
      {stepper}
      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.update.stepRecap.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.update.stepRecap.desc")}</div>
      </div>
      <form className="formContainer" onSubmit={submitForm}>
        <div className="flex flex-col w-full gap-10">
          <ServicesRecapTable
            className={"expand formSection"}
            tableName={accountData.description}
            servicesData={[
              {
                name: t("delivery.accounts.add.stepRecap.serviceRecap.type"),
                value: getAccountTypeTranslation(accountData.type),
              },
              {
                name: t("delivery.accounts.add.stepRecap.serviceRecap.plan"),
                value: t(`delivery.accounts.add.stepPlan.plan.${formData.plan}.label`),
              },
              {
                name: t("delivery.accounts.add.stepRecap.serviceRecap.volume"),
                value: formatter.format(selectedTier.quota),
              },

              formData.plan !== deliveryPlans.FREE && formData.payment_method && !hidePrices
                ? {
                    name: t("delivery.accounts.add.stepRecap.serviceRecap.paymentType"),
                    value: t("radiobtn.label.payment." + formData.payment_method),
                  }
                : null,
            ]}
          />

          {hidePrices ? (
            <div className="inputFull2 bg-[--bg] px-2 py-1 flex flex-col">
              TODO: In fattura troverai il prezzo pattuito con il tuo fornitore
            </div>
          ) : (
            <BillRecap
              className="expand"
              title={formData.plan === deliveryPlans.PREPAID ? t("label.billing.prepaid") : t("label.billing.monthly")}
              infoFee={<TranslatedString>order.fee.priceVat</TranslatedString>}
              messages={[
                formData.plan === deliveryPlans.MONTHLY
                  ? t("delivery.accounts.add.stepRecap.billRecap.message.monthly")
                  : null,
              ]}
              price={selectedTier.pricing_eur}
              appliedDiscount={appliedDiscount}
            />
          )}
        </div>
        <div className="formFooter">
          <Button color="text" type="button" onClick={onFormCancel}>
            button.cancel
          </Button>
          <Button loading={isFormLoading} color="green">
            button.order
          </Button>
        </div>
      </form>

      <SmallModal modalClassName="" title={t("delivery.accounts.update.stepRecap.modal.title")} opened={isModalOpen}>
        <div className="section">
          {pickedPlan == deliveryPlans.FREE ? (
            <TranslatedString>delivery.accounts.update.stepRecap.modal.info.free</TranslatedString>
          ) : accountData.plan === deliveryPlans.MONTHLY ? (
            <TranslatedString>delivery.accounts.update.stepRecap.modal.info.monthly</TranslatedString>
          ) : (
            t("delivery.accounts.update.stepRecap.modal.info.prepaid")
          )}
        </div>
        <div className="mb-4">
          <Button
            className="self-end"
            onClick={() => {
              resetForm();
              history.push("/delivery/accounts");
            }}
          >
            button.ok
          </Button>
        </div>
      </SmallModal>
    </div>
  );
};

export default Recap;
